module.exports = __webpack_public_path__ + "img/Intro-Notifications.29b92695.png";